/**
 * Keitaro, `/postbacks/keitaro`. Generic PostbackQueryDto. Backoffice, TMA and
 * Telegram agree on this template verbatim.
 */
export const keitaroContract = {
    id: 'keitaro',
    displayName: 'Keitaro',
    route: 'keitaro',
    trackingTagMacro: '{subid}',
    amountBehavior: 'amount comes from {payout} on FTD/CPA/REDEP. currency is not a Keitaro macro; CPA hardcodes EUR.',
    duplicateParamPolicy: 'array-then-tolerant-last-wins',
    caseSensitiveParams: [],
    requiresFixedCurrencyForCpa: true,
    pitfalls: [],
    sourceRefs: ['apps/api/src/modules/postbacks/controllers/postbacks.controller.ts:223-259'],
    events: [
        {
            event: 'REG',
            eventValue: 'registration',
            params: [
                { ourParam: 'uid', macro: '{subid}' },
                { ourParam: 'subid', macro: '{campaign_id}' },
                { ourParam: 'tracking_tag', macro: '{subid}' },
            ],
        },
        {
            event: 'FTD',
            eventValue: 'ftd',
            params: [
                { ourParam: 'uid', macro: '{subid}' },
                { ourParam: 'subid', macro: '{campaign_id}' },
                { ourParam: 'amount', macro: '{payout}' },
                { ourParam: 'tracking_tag', macro: '{subid}' },
            ],
        },
        {
            event: 'QUALIFIED_CPA',
            eventValue: 'cpa',
            params: [
                { ourParam: 'uid', macro: '{subid}' },
                { ourParam: 'subid', macro: '{campaign_id}' },
                { ourParam: 'amount', macro: '{payout}' },
                { ourParam: 'currency', macro: 'EUR' },
                { ourParam: 'tracking_tag', macro: '{subid}' },
            ],
            fixedParams: { currency: 'EUR' },
        },
        {
            event: 'REDEP',
            eventValue: 'redep',
            params: [
                { ourParam: 'uid', macro: '{subid}' },
                { ourParam: 'subid', macro: '{campaign_id}' },
                { ourParam: 'amount', macro: '{payout}' },
                { ourParam: 'tracking_tag', macro: '{subid}' },
            ],
        },
    ],
};
//# sourceMappingURL=keitaro.js.map